import React, { useContext } from "react"
import * as styles from "./Styles/Leaflets.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import { PlaceLeaflet } from "../types/place"
import { PCViewContext } from "../Common/PCViewContext"

const Leaflet = (props) => {
  const leaflet: PlaceLeaflet = props.leaflet
  return (
    <a href={leaflet.link} target="_blank" className={styles.leaflet}>
      <div>
        <img src={leaflet.imageUrl} />
        <p>{leaflet.title}</p>
      </div>
    </a>
  )
}

const Leaflets = (props) => {
  const isPC = useContext(PCViewContext)

  return (
    <div className={cn("leaflets", isPC ? "leaflets--twocol" : "")}>
      {props.leaflets.map((leaflet, i) => (
        <Leaflet leaflet={leaflet} key={i} />
      ))}
    </div>
  )
}
export default Leaflets
